import * as z$1 from "zod/v4";
//#region src/schemas/http/space-name.ts
const MAX_SPACE_NAME_LENGTH = 80;
const spaceNameSchema = z$1.string().trim().min(1).max(80);
//#endregion
export { MAX_SPACE_NAME_LENGTH, spaceNameSchema };

//# sourceMappingURL=space-name.js.map